import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { OpButton } from '../OpButton/OpButton';
import { OpSpace } from '../OpSpace/OpSpace';
import { OpForm } from './OpForm';
import { useConfirmModal } from 'utils/customHooks/useConfirmModal';

import './FormButtons.scss';
import { notification } from 'antd';

interface FormButtonsProps {
    className?: string;
    form: ComponentProps<typeof OpForm>['form'];
    isFormLoading?: boolean;
    isSubmitButtonLoading?: boolean;
    submitButtonLabel?: string;
    leftSlot?: React.ReactNode;
}

export const FormButtons = ({
    className,
    form,
    isFormLoading = false,
    isSubmitButtonLoading = false,
    submitButtonLabel,
    leftSlot
}: FormButtonsProps) => {
    const { t } = useTranslation();
    const confirmModal = useConfirmModal();
    const onResetClick = () => {
        if (form?.isFieldsTouched()) {
            confirmModal({
                title: t('confirmDiscard.title'),
                content: t('confirmDiscard.message'),
                okText: t('confirmDiscard.ok'),
                cancelText: t('confirmDiscard.cancel'),
                onOk: () => {
                    form.resetFields();
                },
            });
        }
    };

    const onSubmitClick = () => {
        form?.validateFields()
            .then((values) => {
                form.submit();
            })
            .catch((errorInfo) => {
                notification.error({
                    message: t('notification.error'),
                    description: t('notification.validationError'),
                    placement: 'bottomRight',
                });
            });
    };

    return (
        <div
            className={clsx('form-button-container', className)}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            }}
        >
            <div>{leftSlot}</div>
            <OpSpace className={clsx('form-buttons', className)} size="middle">
                <OpButton
                    testId="reset-form-button"
                    disabled={isFormLoading}
                    onClick={onResetClick}
                >
                    {t('Reset')}
                </OpButton>
                <OpButton
                    testId="submit-form-button"
                    type="primary"
                    onClick={onSubmitClick}
                    disabled={isFormLoading}
                    loading={isSubmitButtonLoading}
                >
                    {submitButtonLabel ?? t('Save')}
                </OpButton>
            </OpSpace>
        </div>

    );
};